export const InValid = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 80" x="0px" y="0px">
      <title>x, cross, no, clear</title>
      <g>
        <path d="M42.1914,32,52.65,21.5405a1.5,1.5,0,0,0,0-2.1211l-8.07-8.07a1.5,1.5,0,0,0-2.1211,0L32,21.8086,21.541,11.35a1.5,1.5,0,0,0-2.1211,0l-8.07,8.07a1.5,1.5,0,0,0,0,2.1211L21.8086,32,11.35,42.46a1.5,1.5,0,0,0,0,2.1211l8.07,8.07a1.5,1.5,0,0,0,2.1211,0L32,42.1914,42.459,52.65a1.5,1.5,0,0,0,2.1211,0l8.07-8.07a1.5,1.5,0,0,0,0-2.1211ZM43.52,49.4688,33.0605,39.0093a1.4992,1.4992,0,0,0-2.121,0L20.4805,49.4688,14.5313,43.52,24.99,33.0605a1.4992,1.4992,0,0,0,0-2.121L14.5313,20.48l5.9492-5.9487L30.94,24.9907a1.5439,1.5439,0,0,0,2.121,0L43.52,14.5313,49.4688,20.48,39.01,30.94a1.4992,1.4992,0,0,0,0,2.121l10.459,10.46Z" />
      </g>
    </svg>
  );
};
